import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import { useTranslation } from "shared/hooks/useTranslation";
import { useOfflineContext } from "shared/contexts/OfflineContext";

/**
 * Persistent, non-dismissible strip when there is no network (native + web).
 */
export default function OfflineBanner() {
    const { isOnline } = useOfflineContext();
    const { t } = useTranslation();

    if (isOnline) return null;

    return (
        <Box
            role="status"
            aria-live="polite"
            sx={{
                position: "sticky",
                top: 0,
                zIndex: (theme) => theme.zIndex.drawer + 1,
                px: 2,
                py: 1,
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexShrink: 0,
                bgcolor: (theme) =>
                    theme.palette.mode === "dark"
                        ? alpha(theme.palette.warning.dark, 0.35)
                        : alpha(theme.palette.warning.main, 0.22),
                borderBottom: (theme) => `1px solid ${alpha(theme.palette.warning.main, 0.45)}`,
                pt: "calc(8px + env(safe-area-inset-top, 0px))",
            }}
        >
            <CloudOffIcon color="warning" fontSize="small" sx={{ flexShrink: 0 }} />
            <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="body2" fontWeight={700} color="warning.contrastText" component="span" sx={{ mr: 0.75 }}>
                    {t("offline.banner.title")}
                </Typography>
                <Typography variant="body2" color="text.secondary" component="span">
                    {t("offline.banner.subtitle")}
                </Typography>
            </Box>
        </Box>
    );
}
